<template>
<v-select
    class="select"
    :class="{select_compact: compact}"
    :options="options"
    :reduce="(item) => item.value"
    :value="value"
    :clearable="clearable ?? true"
    :searchable="false"
    @input="$emit('input', $event)"
></v-select>
</template>

<script>
export default {
  props: {
    options: {},
    value: {},
    clearable: {},
    compact: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.select {
  background-color: var(--tertiary-bg);
  border-radius: 3px;
  position: relative;
  max-width: 150px;
  width: 100%;

  &:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 8px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 5px 0 5px;
    border-color: $text-secondary transparent transparent transparent;
    pointer-events: none;
  }

  &::v-deep {
    .vs__search {
      &::placeholder {
        color: var(--text-primary);
      }

      &,
      &:focus {
        border: none;
      }
    }

    .vs__dropdown-toggle {
      border: none;
      padding-bottom: 10px;
      padding-top: 3px;
      height: 40px;
    }

    .vs_search {
      display: none;
    }

    .vs__open-indicator {
      position: absolute;
      opacity: 0;
      right: 5px;
      top: 0;
      height: 100%;
      z-index: 1;
    }

    .vs__clear {
      margin-right: 18px;
      margin-top: 4px;
      fill: $text-secondary;
    }

    .vs__selected-options {
      position: relative;
      top: 1px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      flex-wrap: nowrap;
    }

    .vs__selected {
      margin-top: 5px;
      position: relative !important;
      display: block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: var(--text-primary);

      & + .vs__search {
        width: 0px;
        padding: 0;
      }
    }

    .vs__dropdown-menu {
      background-color: var(--bg);
    }

    .vs__dropdown-option {
      padding-left: 8px;
      padding-right: 8px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: var(--text-primary);

      &--highlight,
      &:hover {
        background-color: var(--lighter-primary);
      }
    }
  }

  &_compact {
    &::v-deep {
        .vs__dropdown-toggle {
            border: none;
            padding-bottom: 0px;
            padding-top: 0px;
            height: 30px;
        }

        .vs__selected {
            margin-top: 3px;
        }
    }
  }
}
</style>
